import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// css
import { DataGrid } from "@mui/x-data-grid";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { Link, useNavigate } from "react-router-dom";
import api from "../../../../utils/apidsf";
import { nanoid } from "nanoid";
import swal from "sweetalert";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const BareActTable = ({ editArticle, forrefresh }) => {
  const navigate = useNavigate();
  const [users, sertusers] = useState([]);
  const [refresh, setrefresh] = useState();

  useEffect(async () => {
    let token = JSON.parse(localStorage.getItem("token"));
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    let resid = await api.get("/word-of-day", config);

    let res = await api.get(
      `/admin/dictionary?_id=${resid.data.dictionary_id}`,
      config
    );
    console.log(res?.data?.data[0]);

    sertusers(res?.data?.data[0]);
  }, [forrefresh, refresh]);
  const styleSx = {
    marginBottom: "15px",
  };
  return (
    <div
      style={{
        flex: 4,
      }}
    >
      <Card
        sx={{
          minWidth: 275,
          maxWidth: 600,
          marginLeft: "14vw",
          marginTop: "60px",
        }}
      >
        <CardContent>
          <Typography
            sx={{ fontSize: 14, fontWidth: "bold" }}
            variant="h2"
            gutterBottom
          >
            {users?.word}
          </Typography>
          <Typography sx={styleSx} component="div">
            Word Defination in English :-
          </Typography>
          <Typography sx={styleSx} component="div">
            {users?.defination_eng}
          </Typography>
          <Typography sx={styleSx} component="div">
            Word Meaning in English :-
          </Typography>
          <Typography
            sx={{ mb: 1.5, marginBottom: "25px" }}
            color="text.secondary"
          >
            {users?.meaning_eng}
          </Typography>
          <Typography sx={styleSx} component="div">
            Word Defination in Hindi :-
          </Typography>
          <Typography sx={styleSx} variant="body2">
            {users?.defination_hin}
          </Typography>
          <Typography sx={styleSx} component="div">
            Word Meaning in Hindi :-
          </Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {users?.meaning_hin}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            onClick={() => {
              navigate("/admin/dictionary-table");
            }}
          >
            Set New Word Of Day
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default BareActTable;
